<template>
  <v-dialog v-model="show" persistent transition="dialog-bottom-transition">
    <v-form ref="form" v-model="valid" :lazy-validation="lazy">
      <v-card class="mb-0">
        <v-toolbar dark color="primary">
          <v-btn icon dark @click="show = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
          <v-toolbar-title>
            Nuevo Turno
            <v-spacer></v-spacer>
            <h5>Día: {{ dia }} - Hora: {{ hora }}</h5>
          </v-toolbar-title>
        </v-toolbar>
        <v-card-text>
          <v-row dense>
            <v-col cols="9" sm="5" md="6" class="d-flex" style="gap: 1rem">
              <v-text-field
                v-model="paciente.dni"
                prepend-icon="mdi-account"
                hint="Ingrese el DNI del jugador y apriete enter o toque fuera de este cuadro de texto. Si el jugador ya existe, se verán sus datos. Si el jugador no existe, complete los datos y al guardar el turno el jugador quedará registrado. Puede también buscar el jugador por apellido y nombre haciendo click en la lupa"
                label="D.N.I *"
                dense
                required
                @keypress="onlyNumber"
                @keypress.enter="$event.target.blur()"
                @blur="buscarPacienteDni"
                :rules="requiredRules"
                maxlength="9"
              ></v-text-field>
              <v-btn color="primary" @click="buscarPaciente">
                <v-icon>mdi-magnify</v-icon>
              </v-btn>
            </v-col>
            <v-col
              class="mt-2"
              cols="12"
              sm="4"
              md="3"
              v-if="tiposTurno.length"
            >
              <v-select
                :items="tiposTurno"
                v-model="tipoDeTurno"
                item-text="nombreTipoTurno"
                item-value="idTipoTurno"
                label="Tipo de Turno *"
                dense
                prepend-icon="mdi-account"
                return-object
                no-data-text="No hay Tipos de Turno configurados"
              ></v-select>
            </v-col>
            <v-col
              v-if="tipoDeTurno?.requiereProfesor"
              class="mt-2"
              cols="12"
              sm="4"
              md="3"
            >
              <v-select
                :items="profesores"
                v-model="profesor"
                item-text="apellidoNombreProfesor"
                item-value="idProfesor"
                label="Profesor *"
                dense
                prepend-icon="mdi-account"
                return-object
                no-data-text="No hay profesores configurados"
              ></v-select>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="12" sm="6" md="6">
              <v-text-field
                v-model="paciente.apellidos"
                prepend-icon="mdi-account"
                label="Apellidos *"
                maxlength="50"
                :rules="requiredRules"
                @blur="upper"
                dense
                required
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <v-text-field
                v-model="paciente.nombres"
                prepend-icon="mdi-account"
                label="Nombres *"
                maxlength="50"
                :rules="requiredRules"
                @blur="upperNombres"
                dense
                required
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="12" sm="6" md="6">
              <v-text-field
                v-model="paciente.fechaNac"
                :value="paciente.fechaNac"
                label="Fecha de Nacimiento"
                prepend-icon="mdi-calendar"
                type="date"
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <v-select
                :items="sexo"
                v-model="paciente.sexo"
                item-text="paciente.sexo"
                item-value="paciente.sexo"
                label="Sexo"
                dense
                prepend-icon="mdi-account"
              ></v-select>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="12" sm="6" md="6">
              <v-text-field
                v-model="paciente.direccion"
                prepend-icon="mdi-map-marker"
                label="Direccion"
                maxlength="80"
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <v-text-field
                v-model="paciente.localidad"
                prepend-icon="mdi-map-marker"
                label="Localidad"
                maxlength="80"
                dense
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col
              cols="12"
              sm="4"
              md="4"
              v-if="!this.$store.state.usuario.institucion.notificaWA"
            >
              <v-text-field
                v-model="paciente.celular"
                prepend-icon="mdi-cellphone"
                label="Celular"
                maxlength="50"
                dense
                @keypress="onlyNumber"
              ></v-text-field>
            </v-col>
            <v-col
              cols="12"
              sm="4"
              md="4"
              v-if="this.$store.state.usuario.institucion.notificaWA"
            >
              <v-text-field
                v-model="paciente.celular"
                prepend-icon="mdi-cellphone"
                :label="`Celular ${celularObligatorio ? '*' : ''}`"
                maxlength="50"
                hint="Ingrese el celular con la característica, sin 0, sin 15 y sin guiones. Ej: 1135036549"
                dense
                :rules="
                  celularObligatorio ? celularObligatorioRules : celularRules
                "
                @keypress="onlyNumber"
                @blur="trimCelular()"
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="4" md="4">
              <v-text-field
                v-model="paciente.telefono"
                prepend-icon="mdi-phone"
                label="Telefono"
                maxlength="50"
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="4" md="4">
              <v-text-field
                v-model="paciente.mail"
                prepend-icon="mdi-email"
                :label="`E-mail ${emailObligatorio ? '*' : ''}`"
                :rules="emailObligatorio ? emailRulesObligatorio : emailRules"
                dense
                maxlength="80"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="12" sm="6" md="6">
              <v-text-field
                v-model="paciente.observaciones"
                prepend-icon="mdi-account"
                label="Observaciones del Jugador"
                dense
              ></v-text-field>
            </v-col>
            <v-col cols="12" sm="6" md="6">
              <v-text-field
                v-model="turno.observaciones"
                prepend-icon="mdi-account"
                label="Observaciones del Turno"
                dense
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="12" sm="4" md="2">
              <v-select
                :items="getIntervalos"
                prepend-icon="mdi-calendar-multiple"
                v-model="turno.cantIntervalos"
                label="Cantidad turnos a ocupar *"
                :disabled="entreTurno == 1"
                dense
              ></v-select>
            </v-col>
            <v-col cols="12" sm="4" md="3" class="ml-4 turno-fijo">
              <v-switch
                dense
                v-model="turnoFijo"
                label="Turno Fijo"
                hint="Los turnos fijos se dan hasta fin de año. Se deberán volver a dar al comenzar el siguiente año."
                persistent-hint
              ></v-switch>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions>
          <h6 style="color: indigo" v-if="paciente.idPaciente != null">
            {{ tipoPaciente }}
          </h6>
          <v-spacer></v-spacer>
          <v-btn text color="grey lighten-1" @click.stop="show = false"
            >Cancelar</v-btn
          >
          <v-btn color="success" :disabled="!valid" @click.stop="guardarTurno"
            >Guardar</v-btn
          >
        </v-card-actions>
        <BuscarJugadorTurno
          :visible="showBuscarPaciente"
          @close="showBuscarPaciente = false"
          @seleccionarPaciente="seleccionarPaciente($event)"
        ></BuscarJugadorTurno>
      </v-card>
    </v-form>
  </v-dialog>
</template>

<script>
import axios from "@/axios-auth";
import BuscarJugadorTurno from "./BuscarJugadorTurno.vue";
import { cantSemanasInstitucion } from "./configuracionesTurno.js";
import { showAlert } from "@/utils/toast";

export default {
  data: (vm) => ({
    horaTurno: null,
    paciente: {
      dni: null,
      apellidos: null,
      nombres: null,
      fechaNac: null,
      sexo: null,
      direccion: null,
      localidad: null,
      mail: null,
      telefono: null,
      celular: null,
      observaciones: null,
      antecedentes: "",
      idPaciente: null,
      antecedentesFamiliares: null,
      esGestante: false,
    },
    vllamada: false,
    turnoFijo: false,
    showBuscarPaciente: false,
    turno: {
      idTurno: null,
      cantIntervalos: null,
      observaciones: null,
      cantSemanas: null,
      cadaDosSemanas: false,
    },
    intervalos: [1, 2, 3, 4, 5, 6, 7, 8],
    intervalosADN: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12],
    semanas: null,
    sexo: ["FEMENINO", "MASCULINO", "OTRO"],
    valid: false,
    lazy: false,
    tipoPaciente: null,
    numAfiliado: "",
    requiredRules: [(v) => !!v || "Dato obligatorio"],
    emailRules: [
      (v) =>
        !v ||
        /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/.test(v) ||
        "E-mail inválido",
    ],
    celularRules: [(v) => !v || v.length == 10 || "Debe tener 10 caracteres"],
    celularObligatorioRules: [
      (v) => !v || v.length == 10 || "Debe tener 10 caracteres",
      (v) => !!v || "Dato obligatorio",
    ],
    emailRulesObligatorio: [
      (v) =>
        !v ||
        /^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/.test(v) ||
        "E-mail inválido",
      (v) => !!v || "Dato obligatorio",
    ],
    tiposTurno: [],
    tipoDeTurno: null,
    profesor: null,
    profesores: [],
  }),

  props: [
    "visible",
    "dia",
    "hora",
    "idProfesional",
    "tiempoTurno",
    "entreTurno",
    "tipoTurno",
  ],

  components: {
    BuscarJugadorTurno,
  },
  computed: {
    show: {
      get() {
        if (this.visible) this.setearModels();
        return this.visible;
      },
      set(value) {
        if (!value) {
          this.$refs.form.resetValidation();
          this.vaciarModels();
          this.paciente.dni = "";
          document.getElementsByClassName("v-dialog--active")[0].scrollTop = 0;
          this.$emit("close");
        }
      },
    },
    celularObligatorio() {
      return [195, 436].includes(
        this.$store.state.usuario.institucion.idInstitucion,
      );
    },
    emailObligatorio() {
      return [195].includes(
        this.$store.state.usuario.institucion.idInstitucion,
      );
    },
    getIntervalos() {
      return [304, 466].includes(
        this.$store.state.usuario.institucion.idInstitucion,
      )
        ? this.intervalosADN
        : this.intervalos;
    },
  },

  methods: {
    trimCelular() {
      this.paciente.celular = this.paciente.celular.toString().trim();
    },
    validarFechaNacimiento() {
      if (this.paciente.fechaNac == null) return true;
      else {
        if (this.paciente.fechaNac.toString().length > 10) return false;
        else return true;
      }
    },
    guardarTurno() {
      this.$swal({
        title: "Guardar Turno",
        text: "¿Desea registrar el turno?",
        icon: "success",
        type: "success",
        showCancelButton: true,
        background: "#ececec",
        confirmButtonText: "Si",
        cancelButtonText: "No",
        showCloseButton: true,
        showLoaderOnConfirm: true,
      }).then(async (result) => {
        if (result.value) {
          //this.$swal('Turno g', 'You successfully deleted this file', 'success')

          if (
            this.tipoDeTurno?.requiereProfesor &&
            !this.profesor?.idProfesor
          ) {
            this.showAlert({
              timer: 3500,
              icon: "warning",
              title:
                "El tipo de turno elegido requiere profesor, seleccione uno por favor.",
              vm: this,
            });
            return;
          }

          const datosTurno = {
            idInstitucion: this.$store.state.usuario.institucion.idInstitucion,
            dniPaciente: this.paciente.dni,
            apellidoPaciente: this.paciente.apellidos,
            nombrePaciente: this.paciente.nombres,
            fechaNacimientoString: this.paciente.fechaNac,
            sexo: this.paciente.sexo,
            direccion: this.paciente.direccion,
            localidad: this.paciente.localidad,
            celular: this.paciente.celular.trim(),
            telefono: this.paciente.telefono.trim(),
            mail: this.paciente.mail.trim(),
            observaciones: this.paciente.observaciones,
            antecedentes: this.paciente.antecedentes,
            antecedentesFamiliares: this.paciente.antecedentesFamiliares,
            esGestante: this.paciente.esGestante,
            idPaciente: this.paciente.idPaciente,
            fechaTurnoString: this.dia,
            horaInicioString: this.hora,
            cantidadIntervalos: this.turno.cantIntervalos,
            duracionTurno: this.turno.cantIntervalos * this.tiempoTurno,
            idprofesional: this.idProfesional,
            estadoTurno: 1,
            esWeb: false,
            entreTurno: this.entreTurno,
            observacionesTurno: this.turno.observaciones,
            esVideoLlamada: this.vllamada,
            cantSemanas: this.turno.cantSemanas,
            usuarioAlta: this.$store.state.usuario.usuario,
            cadaDosSemanas: this.turno.cadaDosSemanas,
            siglaTipoTurno: this.tipoDeTurno?.sigla || "",
            idTipoTurno: this.tipoDeTurno?.idTipoTurno || 0,
            numAfiliado: this.numAfiliado,
            turnoFijo: this.turnoFijo,
            idProfesor: this.profesor?.idProfesor || 0,
          };

          if (
            datosTurno.apellidoPaciente == null ||
            datosTurno.apellidoPaciente == ""
          ) {
            this.showAlert({
              timer: 2500,
              icon: "warning",
              title: "Faltan completar datos obligatorios.",
              vm: this,
            });
            return;
          }
          let isValidDate = this.validarFechaNacimiento();
          if (!isValidDate) {
            this.showAlert({
              icon: "warning",
              title: "La fecha de nacimiento no tiene un formato válido.",
              vm: this,
              timer: 2800,
            });
            return;
          }
          const { data } = await axios.get("Turnos/VerificarTurnoPacienteDia", {
            params: {
              idPaciente: datosTurno.idPaciente,
              fechaTurnoString: datosTurno.fechaTurnoString,
              idProfesional: datosTurno.idprofesional,
            },
          });
          if (data) {
            this.$swal({
              title: "Jugador con turno en el día",
              text: "El jugador ya posee un turno registrado para hoy. ¿Desea de todos modos registrar el turno?",
              icon: "success",
              type: "success",
              showCancelButton: true,
              background: "#ececec",
              confirmButtonText: "Si",
              cancelButtonText: "No",
              showCloseButton: true,
              showLoaderOnConfirm: true,
            }).then(async (result) => {
              if (result.value) {
                this.grabarTurno(datosTurno);
              }
            });
          } else {
            this.grabarTurno(datosTurno);
          }
        } else {
          //this.$swal('Cancelled', 'Your file is still intact', 'info')
        }
      });
    },
    grabarTurno(datosTurno) {
      let self = this;
      axios
        .post("/Turnos/GuardarTurno", datosTurno)
        .then((response) => {
          if (response.data == "Turnos Existentes") {
            self.showAlert({
              timer: 2800,
              icon: "warning",
              title:
                "Existen turnos ya reservados dentro de la duración del turno que quiere reservar.",
              vm: self,
            });
          } else {
            if (response.data == "Turnos Existentes Semana") {
              self.showAlert({
                timer: 4000,
                icon: "warning",
                title:
                  "Existen turnos dados en algunas de las semanas siguientes hasta fin de año para el turno fijo.",
                vm: self,
              });
            } else {
              if (response.data == "Tope") {
                self.showAlert({
                  timer: 2800,
                  icon: "warning",
                  title: `${
                    self.$store.state.usuario.institucion.esEmpresa
                      ? "El profesional no atiende en la sede seleccionada"
                      : "Supera la cantidad máxima de turnos diarios para la cancha."
                  }`,
                  vm: self,
                });
              } else {
                if (response.data == "Reservado") {
                  self.showAlert({
                    timer: 2800,
                    icon: "warning",
                    title:
                      "Disculpe, el turno acaba de ser tomado. Reserve otro por favor.",
                    vm: self,
                  });
                } else {
                  self.$refs.form.resetValidation();
                  self.paciente.dni = "";
                  document.getElementsByClassName(
                    "v-dialog--active",
                  )[0].scrollTop = 0;
                  if (self.vllamada == false) {
                    self.showAlert({
                      timer: 2200,
                      icon: "success",
                      title: "Turno reservado.",
                      vm: self,
                    });
                  } else {
                    self.showAlert({
                      timer: 3200,
                      icon: "success",
                      title:
                        "Turno reservado. Se enviará un email al jugador con las instrucciones para la videoconsulta.",
                      vm: self,
                    });
                  }
                  self.vaciarModels();
                  self.$emit("turnoRegistrado");
                }
              }
            }
          }
        })
        .catch((error) => {
          self.showAlert({
            timer: 2000,
            icon: "warning",
            title: "El turno no pudo ser reservado.",
            vm: this,
          });
        })
        .finally(() => {});
    },
    seleccionarPaciente(item) {
      this.paciente.dni = item.nrodocumento;
      this.paciente.apellidos = item.apellidos;
      this.paciente.nombres = item.nombres;
      if (item.fechanacimiento == "0001-01-01T00:00:00")
        this.paciente.fechaNac = "";
      else this.paciente.fechaNac = item.fechanacimiento.substring(0, 10);
      this.paciente.sexo = item.sexo;
      this.paciente.localidad = item.localidad;
      this.paciente.direccion = item.direccion;
      this.paciente.celular = item.celular;
      this.paciente.mail = item.email;
      this.paciente.telefono = item.telefono;
      this.paciente.observaciones = item.observaciones;
      this.paciente.antecedentes = item.antecedentes;
      this.paciente.antecedentesFamiliares = item.antecedentesFamiliares;
      this.paciente.esGestante = item.esGestante;
      this.paciente.idPaciente = item.idpaciente;
      this.tipoPaciente = "Jugador Existente";
      this.showBuscarPaciente = false;
    },

    buscarPacienteDni() {
      if (isNaN(this.paciente.dni)) {
        this.showAlert({
          timer: 3200,
          icon: "warning",
          title: "El D.N.I. debe estar compuesto sólo por números.",
          vm: this,
        });
        this.paciente.dni = "";
        this.paciente.idPaciente = 0;
        return;
      }
      if (this.paciente.dni != "" && this.paciente.dni != null)
        this.paciente.dni = parseInt(this.paciente.dni);

      const pacientesData = {
        dni: this.paciente.dni,
        idInstitucion: this.$store.state.usuario.institucion.idInstitucion,
      };
      let self = this;
      axios
        .get("/Paciente/GetPacienteDniTurno?", {
          params: {
            dni: pacientesData.dni,
            idInstitucion: pacientesData.idInstitucion,
          },
        })
        .then(function (response) {
          if (response.data != "" && response.data != null) {
            self.paciente.apellidos = response.data.apellidos;
            self.paciente.nombres = response.data.nombres;
            self.paciente.idPaciente = response.data.idpaciente;
            if (response.data.fechanacimiento == "0001-01-01T00:00:00")
              self.paciente.fechaNac = "";
            else
              self.paciente.fechaNac = response.data.fechanacimiento.substring(
                0,
                10,
              );
            self.paciente.sexo = response.data.sexo;
            self.paciente.direccion = response.data.direccion;
            self.paciente.localidad = response.data.localidad;
            self.paciente.telefono = response.data.telefono;
            self.paciente.celular = response.data.celular;
            self.paciente.mail = response.data.email;
            self.paciente.antecedentes = response.data.antecedentes;
            self.paciente.antecedentesFamiliares =
              response.data.antecedentesFamiliares;
            self.paciente.esGestante = response.data.esGestante;
            self.paciente.observaciones = response.data.observaciones;
            self.tipoPaciente = "Jugador Existente";
          } else {
            self.vaciarModels();
            self.paciente.idPaciente = 0;
            self.tipoPaciente = "Jugador Nuevo - Ingrese sus datos";
          }
        })
        .catch(function (error) {});
    },
    parseDate(date) {
      return (
        date.substring(8, 10) +
        "/" +
        date.substring(5, 7) +
        "/" +
        date.substring(0, 4)
      );
    },
    onlyNumber($event) {
      let keyCode = $event.keyCode ? $event.keyCode : $event.which;
      if (keyCode < 48 || keyCode > 57) {
        // 46 is dot
        $event.preventDefault();
      }
    },
    upper() {
      if (this.paciente.apellidos != null)
        this.paciente.apellidos = this.paciente.apellidos
          .toString()
          .toUpperCase();
    },
    upperNombres() {
      if (this.paciente.nombres != null)
        this.paciente.nombres = this.paciente.nombres.toString().toUpperCase();
    },
    buscarPaciente() {
      this.showBuscarPaciente = true;
    },
    vaciarModels() {
      this.paciente.apellidos = "";
      this.paciente.nombres = "";
      this.paciente.direccion = "";
      this.paciente.localidad = "";
      this.paciente.celular = "";
      this.paciente.telefono = "";
      this.paciente.mail = "";
      this.paciente.observaciones = "";
      this.paciente.antecedentes = "";
      this.paciente.antecedentesFamiliares = "";
      this.paciente.esGestante = false;
      this.paciente.fechaNac = null;
      this.paciente.sexo = null;
      this.paciente.idPaciente = null;
      this.turno.cantIntervalos = this.getIntervalos[0];
      this.turno.observaciones = "";
      this.turno.cantSemanas = 1;
      this.turno.cadaDosSemanas = false;
      this.numAfiliado = "";
      this.vllamada = false;
      this.turnoFijo = false;
      this.profesor = null;
    },

    showAlert(alertInfo) {
      showAlert(alertInfo);
    },
    async setearModels() {
      this.turno.cantSemanas = 1;
      this.turno.cadaDosSemanas = false;

      const { data: tiposTurno } = await axios.get(
        "/Profesional/GetTiposTurno",
        {
          params: {
            idInstitucion: this.$store.state.usuario.institucion.idInstitucion,
          },
        },
      );
      this.tiposTurno = (tiposTurno || []).filter((tt) => !tt.disponibleWeb);
      this.tipoDeTurno = this.tiposTurno.find((tt) => tt.porDefecto);

      const { data: profesores } = await axios.get(
        "/Profesional/BuscarProfesores",
        {
          params: {
            idInstitucion: this.$store.state.usuario.institucion.idInstitucion,
          },
        },
      );
      this.profesores = profesores || [];
      if (this.profesores.length) {
        this.profesor = this.profesores[0];
      }
    },
  },
  watch: {
    date() {
      this.dateFormatted = this.formatDate(this.date);
    },
    tipoDeTurno: {
      handler(val) {
        if (val && !val.requiereProfesor) {
          this.idProfesor = null;
        }
        if (val) {
          this.turnoFijo = val.esTurnoFijo ?? false;
        }
        if (val && val.duracion) {
          this.turno.cantIntervalos = val.duracion;
        } else {
          this.turno.cantIntervalos = 1;
        }
      },
      deep: true,
      immediate: true,
    },
  },
  created() {
    this.vaciarModels();
    this.semanas =
      cantSemanasInstitucion[
        this.$store.state.usuario.institucion.idInstitucion
      ] ?? cantSemanasInstitucion["0"];
  },
};
</script>
<style lang="scss">
.cada-dos-semanas {
  .v-input--checkbox {
    margin-top: 0.6rem;
    padding-top: 0;
    .v-input--selection-controls__input {
      margin-right: 2px;
    }
  }
}
.turno-fijo {
  margin-top: -0.8rem;
}
</style>
